import StitchFeaturePage from "../../components/sections/StitchFeaturePage";

const features = [
  { title: "User Research", desc: "Discovery interviews, behavior review, and workflow understanding before layouts are pushed around." },
  { title: "Information Architecture", desc: "Clear page structure and navigation logic so users do not get lost on the way to action." },
  { title: "Wireframes", desc: "Low-friction prototyping to solve structure and flow before visual polish enters the conversation." },
  { title: "Design Systems", desc: "Reusable UI patterns, rules, and visual decisions that scale across pages and products." },
  { title: "High-Fidelity Design", desc: "Premium visual execution for web and product surfaces without sacrificing clarity or speed." },
  { title: "Developer Handoff", desc: "Tidy design files and implementation-ready thinking that reduce translation loss during build." },
];

const UiUx = () => (
  <StitchFeaturePage
    label="UI / UX DESIGN"
    title="Interfaces built"
    titleAccent="to perform."
    subtitle="Research-driven UX and polished visual design for websites, applications, and internal systems."
    features={features}
    ctaLabel="PLAN YOUR UI / UX PROJECT"
  />
);

export default UiUx;
